import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <MDBFooter  className=''>
      

      <section className='text-dark'>
        <div className='container-full-width text-md-start py-5'>
          <MDBRow>
            <MDBCol md="6" lg="6" xl="6" className='mx-auto mb-4'>
              <h6 className='text-uppercase mb-4'>
                <MDBIcon icon="gem" className="me-3" />
                SUDARSHAN GIRI
              </h6>
              <p>
              Sudarshan began coding in 2014.
              For numerous businesses, Sudarshan has served as a Full Stack Developer, Drupal Developer, and Webmaster.
              He writes code every day.
              </p>
            </MDBCol>

            

            <MDBCol md="6" lg="6" xl="6" className='mx-auto'>
              
              <h6 className='text-uppercase  mb-4'>CONTACT</h6>
              
              <p>
                <a className='text-normal text-decoration-none' href='mailto:sudarshanhang@gmail.com'>
                {/* <MDBIcon icon="envelope" className="me-3" /> */}
                sudarshanhang@gmail.com
                </a>
              
              </p>
             <p>
              <a target='_blank' className='text-normal text-decoration-none' href='https://www.linkedin.com/in/sudarshangiri/' >
                {/* <MDBIcon fab icon="linkedin" className='me-3' /> */}
                linkedin.com/in/sudarshangiri
              </a>
             </p>
             <p>
              <a className='text-normal text-decoration-none' href='https://github.com/sudarshangiri' >
                {/* <MDBIcon fab icon="linkedin" className='me-3' /> */}
               github.com/sudarshangiri
              </a>
             </p>

            
             
            </MDBCol>
          </MDBRow>
        </div>
      </section>

      <div className='p-4 text-dark border-top border-bottom' >
        © {currentYear} sudarshangiri.com.np
      </div>
    </MDBFooter>
  );
}
